export enum AppUpdateType {
  EXPO = "EXPO",
  APP = "APP",
}

export type UpdateComparison = {
  currentVersion: string;
  latestVersion: string;
  isUpdateAvailable: boolean;
  type: AppUpdateType;
};

export const InitialUnknownUpdate: UpdateComparison = {
  currentVersion: "Unknown",
  latestVersion: "Unknown",
  isUpdateAvailable: false,
  type: AppUpdateType.EXPO,
};

export const InitialUnknownVersion: UpdateComparison = {
  currentVersion: "Unknown",
  latestVersion: "Unknown",
  isUpdateAvailable: false,
  type: AppUpdateType.APP,
};
